import { useEffect, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import { NetworkDirectoryPanel } from 'src/assets/styles/components/network';
import CatalogGallery from 'src/containers/comunidad-network/catalog/CatalogGallery';
import CatalogPhotoPreview from 'src/containers/comunidad-network/catalog/CatalogPhotoPreview';
import { jobPostingsFromRecord } from 'src/containers/comunidad-network/form/networkFormUtils';

const CatalogDetail = ({ inputs, onBack, openJobs = false }) => {
  const editingInputs = { ...inputs, ...(inputs.Guest || {}) };
  const {
    businessName,
    category,
    serviceOffered,
    productDescription,
    facebook,
    instagram,
    businessPhone,
    lastName,
    twitter,
    name,
    email,
    logo,
    catalogImages,
    jobPostings,
    id,
  } = editingInputs;

  const photos = Array.isArray(catalogImages) ? catalogImages.filter(Boolean) : [];
  const photoKey = photos.join('|');
  const postings = jobPostingsFromRecord(jobPostings).filter(
    (posting) => posting.title.trim() || posting.description.trim()
  );
  const [previewIndex, setPreviewIndex] = useState(null);
  const [showJobs, setShowJobs] = useState(false);

  useEffect(() => {
    setPreviewIndex(null);
  }, [photoKey]);

  useEffect(() => {
    setShowJobs(openJobs);
  }, [id, openJobs]);

  const contactName = [name, lastName].filter(Boolean).join(' ');

  return (
    <NetworkDirectoryPanel>
      {onBack && (
        <div className="directory-panel__toolbar">
          <button type="button" className="directory-panel__back" onClick={onBack}>
            <Icon name="arrow left" />
            Volver al listado
          </button>
          <button
            type="button"
            className="directory-panel__close"
            onClick={onBack}
            aria-label="Cerrar y volver al directorio"
          >
            <Icon name="close" />
          </button>
        </div>
      )}

      <header className="directory-panel__header">
        {logo && (
          <img
            className="directory-panel__logo"
            src={logo}
            alt={`Logo de ${businessName || 'la empresa'}`}
          />
        )}
        <div className="directory-panel__identity">
          <p className="directory-panel__eyebrow">{category || 'Empresa'}</p>
          <div className="directory-panel__title-row">
            <h2 className="directory-panel__title">{businessName}</h2>
            {postings.length > 0 && (
              <button
                type="button"
                className="directory-panel__jobs-cta"
                onClick={() => {
                  setShowJobs((current) => !current);
                  setPreviewIndex(null);
                }}
              >
                {showJobs ? 'Ver producto o servicio' : 'Ver vacantes'}
              </button>
            )}
          </div>
        </div>
      </header>

      {showJobs ? (
        postings.map((posting) => (
          <section className="directory-panel__section" key={posting.id}>
            <h3 className="directory-panel__job-title">{posting.title}</h3>
            {posting.description ? (
              <p className="directory-panel__text">{posting.description}</p>
            ) : null}
          </section>
        ))
      ) : (
        <>
          {serviceOffered && (
            <section className="directory-panel__section">
              <h3 className="directory-panel__label">Producto o servicio</h3>
              <p className="directory-panel__text">{serviceOffered}</p>
            </section>
          )}

          {productDescription && (
            <section className="directory-panel__section">
              <h3 className="directory-panel__label">Descripción</h3>
              <p className="directory-panel__text">{productDescription}</p>
            </section>
          )}

          <CatalogGallery photos={photos} businessName={businessName} onSelect={setPreviewIndex} />
        </>
      )}
      <CatalogPhotoPreview
        photos={photos}
        index={previewIndex}
        businessName={businessName}
        onClose={() => setPreviewIndex(null)}
        onIndexChange={setPreviewIndex}
      />

      <section className="directory-panel__section">
        <h3 className="directory-panel__label">Contacto</h3>
        <ul className="directory-panel__list">
          {businessPhone && (
            <li className="directory-panel__item">
              <Icon name="phone" />
              <span>{businessPhone}</span>
            </li>
          )}
          {contactName && (
            <li className="directory-panel__item">
              <Icon name="user outline" />
              <span>{contactName}</span>
            </li>
          )}
          {email && (
            <li className="directory-panel__item">
              <Icon name="mail outline" />
              <a href={`mailto:${email}`}>{email}</a>
            </li>
          )}
          {facebook && (
            <li className="directory-panel__item">
              <Icon name="facebook f" />
              <a href={`https://www.facebook.com/${facebook}`} target="_blank" rel="noreferrer">
                {facebook}
              </a>
            </li>
          )}
          {instagram && (
            <li className="directory-panel__item">
              <Icon name="instagram" />
              <a href={`https://www.instagram.com/${instagram}`} target="_blank" rel="noreferrer">
                {instagram}
              </a>
            </li>
          )}
          {twitter && (
            <li className="directory-panel__item">
              <Icon name="twitter" />
              <a href={`https://twitter.com/${twitter}`} target="_blank" rel="noreferrer">
                {twitter}
              </a>
            </li>
          )}
        </ul>
      </section>
    </NetworkDirectoryPanel>
  );
};

export default CatalogDetail;
